import { motion } from "framer-motion";
import {
  FloatingCloud,
  FloatingMoon,
  Sparkle,
  SleepZ,
} from "./SleepDecorations";

export default function GuaranteeSection() {
  return (
    <section className="relative py-24 bg-[#fbf5ed] overflow-hidden">
      {/* Soft sleep decorations */}
      <FloatingCloud
        className="absolute top-0 -left-12 text-[#6d28d9] drift-slow"
        size={220}
      />
      <FloatingMoon
        className="absolute top-6 right-[-30px]"
        size={180}
        tone="dark"
      />
      <SleepZ
        className="absolute top-[30%] right-[18%] text-violet-500"
        size={56}
      />
      <Sparkle
        className="absolute bottom-[25%] left-[12%] text-rose-500/60"
        size={26}
      />
      <FloatingCloud
        className="absolute bottom-0 right-0 text-violet-200 drift-slow"
        size={200}
      />

      <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-violet-300/20 blur-[120px]" />

      <div className="relative max-w-5xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="flex justify-center"
        >
          <picture>
            <source srcSet="/images/guarantee-7days.webp" type="image/webp" />
            <img
              src="/images/guarantee-7days.jpeg"
              alt="7 dias de garantia — Teste o curso por 7 dias. Se não gostar, devolvemos 100% do dinheiro. Sem perguntas. O risco é todo meu, a transformação toda sua."
              className="w-full max-w-md lg:max-w-xl h-auto rounded-3xl shadow-[0_40px_120px_-30px_rgba(76,29,149,0.45)]"
              loading="lazy"
            />
          </picture>
        </motion.div>
      </div>
    </section>
  );
}
